// extracted by mini-css-extract-plugin
export default {"BuildingAdvantagesBlock":"BuildingAdvantagesBlock_BuildingAdvantagesBlock__IrVOK","info":"BuildingAdvantagesBlock_info__ULzjw","advantage":"BuildingAdvantagesBlock_advantage__3UbRq"};